import {
  ScanLine, LayoutDashboard, ShoppingCart, Package, Tags, Users as UsersIcon,
  Receipt, Store, ShoppingBag, Printer, FileBarChart, HandCoins, Boxes, Clock, DatabaseBackup, CreditCard, Server, Palette, ScrollText,
  ArrowDownToLine, ArrowUpFromLine, ClipboardCheck, Activity, BellRing, ShieldCheck, Keyboard,
} from "lucide-react";
import { hasModuleAccess, permissionForPath } from "@/lib/user-permissions";

export const NAV = [
  {
    section: "Administrasi Master",
    items: [
      { to: "/master/platform", label: "Platform", icon: CreditCard, roles: ["admin"], masterOnly: true },
      { to: "/master/tenants", label: "Kelola Tenant", icon: Store, roles: ["admin"], masterOnly: true },
      { to: "/master/system", label: "Status VPS", icon: Server, roles: ["admin"], masterOnly: true },
      { to: "/master/backup", label: "Backup NAS & Jadwal", icon: DatabaseBackup, roles: ["admin"], masterOnly: true },
    ],
  },
  {
    section: null,
    items: [{ to: "/pos", label: "Kasir", icon: ShoppingCart, roles: ["admin", "cashier"] }],
  },
  {
    section: "Dashboard",
    items: [{ to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["admin"] }],
  },
  {
    section: "Penjualan",
    items: [
      { to: "/transactions", label: "Transaksi & Retur", icon: Receipt, roles: ["admin", "cashier"] },
      { to: "/piutang", label: "Piutang Pelanggan", icon: HandCoins, roles: ["admin", "cashier"] },
      { to: "/promotions", label: "Promo Otomatis", icon: Tags, roles: ["admin"] },
      { to: "/whatsapp", label: "WhatsApp Toko", icon: ScanLine, roles: ["admin"], tenantOnly: true },
    ],
  },
  {
    section: "Produk & Inventori",
    items: [
      { to: "/products", label: "Daftar Produk", icon: Package, roles: ["admin", "warehouse"] },
      { to: "/categories", label: "Kategori", icon: Tags, roles: ["admin"] },
      { to: "/barcode-pda", label: "Barcode PDA", icon: ScanLine, roles: ["warehouse"] },
      { to: "/stok?tab=stok", label: "Stok Saat Ini", icon: Boxes, roles: ["admin"] },
      { to: "/stok?tab=masuk", label: "Stok Masuk", icon: ArrowDownToLine, roles: ["admin"] },
      { to: "/stok?tab=keluar", label: "Stok Keluar", icon: ArrowUpFromLine, roles: ["admin"] },
      { to: "/stok?tab=opname", label: "Stok Opname", icon: ClipboardCheck, roles: ["admin"] },
      { to: "/stok?tab=pergerakan", label: "Pergerakan Stok", icon: Activity, roles: ["admin"] },
      { to: "/branch-stock", label: "Stok Semua Cabang", icon: Boxes, roles: ["admin"] },
      { to: "/stock-alerts", label: "Peringatan Stok", icon: BellRing, roles: ["admin"], tenantOnly: true },
    ],
  },
  {
    section: "Gudang & Transfer",
    items: [
      { to: "/warehouse", label: "Penerimaan Gudang", icon: ScanLine, roles: ["admin", "warehouse"] },
      { to: "/branch-transfers", label: "Transfer Antar Cabang", icon: ArrowUpFromLine, roles: ["admin", "warehouse", "cashier"] },
      { to: "/stock-requests", label: "Permintaan Stok", icon: Package, roles: ["admin", "cashier", "warehouse"] },
    ],
  },
  {
    section: "Pembelian",
    items: [
      { to: "/purchases", label: "Faktur & Retur Pembelian", icon: ShoppingBag, roles: ["admin"] },
      { to: "/purchase-suggestions", label: "Saran Pembelian", icon: BellRing, roles: ["admin"] },
    ],
  },
  {
    section: "Pelanggan & Supplier",
    items: [
      { to: "/contacts", label: "Pelanggan", icon: UsersIcon, roles: ["admin", "cashier"] },
      { to: "/suppliers", label: "Supplier", icon: ShoppingBag, roles: ["admin"] },
    ],
  },
  {
    section: "Laporan",
    items: [
      { to: "/reports", label: "Laporan", icon: FileBarChart, roles: ["admin"] },
      { to: "/shifts", label: "Riwayat Shift", icon: Clock, roles: ["admin"] },
    ],
  },
  {
    section: "Karyawan & Akses",
    items: [
      { to: "/users", label: "Pengguna & Hak Akses", icon: UsersIcon, roles: ["admin"] },
      { to: "/supervisor", label: "Persetujuan Supervisor", icon: ShieldCheck, roles: ["admin"] },
      { to: "/audit-logs", label: "Log Aktivitas", icon: ScrollText, roles: ["admin"] },
    ],
  },
  {
    section: "Pengaturan",
    items: [
      { to: "/stores", label: "Profil Toko", icon: Store, roles: ["admin"] },
      { to: "/settings", label: "Printer", icon: Printer, roles: ["admin"] },
      { to: "/shortcut-settings", label: "Shortcut Keyboard", icon: Keyboard, roles: ["admin"], tenantOnly: true },
      { to: "/payment-methods", label: "Metode Pembayaran", icon: CreditCard, roles: ["admin"] },
      { to: "/backup", label: "Backup & Restore", icon: DatabaseBackup, roles: ["admin"] },
      { to: "/appearance", label: "Tampilan / Tema", icon: Palette, roles: ["admin"] },
    ],
  },
];

export const ROLE_LABELS = { admin: "Administrator", warehouse: "Gudang", cashier: "Kasir" };
export function navigationFor(role, tenantKind, account = null) {
 const allowed = item => {
    if (item.masterOnly && tenantKind !== "master") return false;
   if (item.tenantOnly && tenantKind !== "tenant") return false;
   if (account?.permission_mode === "custom" && role !== "admin") {
     if (!item.to && item.children) return true;
     const module = item.to ? permissionForPath(item.to.split("?")[0]) : null;
     if (!module) return false;
     return hasModuleAccess(account, module, module === "pos" ? "write" : "read");
   }
   return item.roles.includes(role);
 };
 const filterItem = item => {
   if (!allowed(item)) return null;
   if (!item.children) return item;
   const children = item.children.map(filterItem).filter(Boolean);
   return children.length ? { ...item, children } : null;
 };
 return NAV.map(group => ({ ...group, items: group.items.map(filterItem).filter(Boolean) })).filter(group => group.items.length);
}
